<template>
  <Card>
    <div class="banner" :class="tone">
      <div class="icon">{{ icon }}</div>
      <h2 class="title">{{ title }}</h2>
      <p class="desc">{{ description }}</p>
    </div>
    <template #footer>
      <button class="btn btn-primary full" @click="$emit('close')">關閉</button>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Card from './Card.vue'
import { QrSessionState } from '@/types/qr'

const props = defineProps<{
  state: QrSessionState
  message?: string
}>()

defineEmits<{ (e: 'close'): void }>()

const config = computed(() => {
  switch (props.state) {
    case QrSessionState.CANCELED:
      return { tone: 'warn', icon: '✕', title: '交易已取消', desc: '您已取消這筆交易。' }
    case QrSessionState.EXPIRED:
      return { tone: 'warn', icon: '⏱', title: '操作逾時', desc: '請重新掃描販賣機 QR 碼。' }
    case QrSessionState.KICKED:
      return {
        tone: 'warn',
        icon: '⚠',
        title: '已被新交易取代',
        desc: '同台販賣機有新的掃碼,本次交易已停止。',
      }
    default:
      return { tone: 'warn', icon: '!', title: '無法繼續', desc: props.message ?? '' }
  }
})
const tone = computed(() => config.value.tone)
const icon = computed(() => config.value.icon)
const title = computed(() => config.value.title)
const description = computed(() => props.message || config.value.desc)
</script>

<style scoped>
.banner {
  text-align: center;
  padding: 12px 0;
}
.icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 50%;
  color: #fff;
  font-size: 28px;
  line-height: 56px;
}
.warn .icon {
  background: #f59e0b;
}
.title {
  margin: 0;
  font-size: 20px;
  color: #111827;
}
.desc {
  margin: 8px 0 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}
.full {
  width: 100%;
}
</style>
